import { ConfirmFormData } from 'src/app/models/confirm-data/confirm-form-data.model';
import { DeliveryCourierFormData } from 'src/app/models/delivery-courier/delivery-courier-form-data.model';
import { DeliveryPointFormData } from 'src/app/models/delivery-courier/delivery-point-form-data.model';
import { ShipmentFormData } from 'src/app/models/shipment/shipment-form-data.model';
import { ShippingCourierFormData } from 'src/app/models/shipping-courier/shipping-courier-form-data.model';
import { ShippingPointFormData } from 'src/app/models/shipping-courier/shipping-point-form-data.model';

export interface FormsDataState {
  shippingCourierFormData?: ShippingCourierFormData;
  shippingPointFormData?: ShippingPointFormData;
  deliveryCourierFormData?: DeliveryCourierFormData;
  deliveryPointFormData?: DeliveryPointFormData;
  shipmentFormData?: ShipmentFormData;
  confirmFormData?: ConfirmFormData;
  selectedPartners: string[];
}

export const initialState: FormsDataState = {
  shippingCourierFormData: undefined,
  shippingPointFormData: undefined,
  deliveryCourierFormData: undefined,
  deliveryPointFormData: undefined,
  shipmentFormData: undefined,
  selectedPartners: [],
};
